module.exports = __webpack_public_path__ + "assets/icon-journey-whatsapp.67796c6b.svg";